import Skeleton, { SkeletonProps } from 'antd/lib/skeleton'

export { Skeleton }
export type { SkeletonProps }
